import {AxiosRequestConfig} from "axios";
import {getCookieByName} from "../../helpers/getCookieByName";

class AuthInterceptor {
    private getToken: any;

    setAuthGetter = (getToken: any) => {
        this.getToken = getToken;
    }

    intercept = async (config: AxiosRequestConfig) => {
        if (window.refreshToken) {
            if (Math.floor(Date.now() / 1000) + 30 > (getCookieByName('app.at_exp') || 0)) {
                await window.refreshToken()
                return config
            } else {
                return config
            }
        }

    }
}

export const authInterceptor = new AuthInterceptor()
